// import React from 'react';

// interface MarketCardLayout1Props {
//   colors: {
//     background: string;
//     text: string;
//     button: string;
//     buttonText: string;
//     status: string;
//     border: string;
//   };
// }

// const MarketCardLayout1: React.FC<MarketCardLayout1Props> = ({ colors }) => {
//   return (
//     <div 
//       className="p-4 rounded-lg border-2"
//       style={{
//         backgroundColor: colors.background,
//         borderColor: colors.border,
//         color: colors.text
//       }}
//     >
//       <div className="flex items-center justify-between mb-2">
//         <h3 className="font-semibold text-lg">MAHADEVI</h3>
//         <span 
//           className="text-sm font-medium"
//           style={{ color: colors.status }}
//         >
//           Betting is running for close
//         </span>
//       </div>
      
//       <div className="text-2xl font-bold mb-2">399-1</div>
      
//       <div className="flex items-center justify-between mb-3">
//         <div className="text-sm">
//           <span className="font-medium">Open</span>
//           <span className="ml-2" style={{ color: colors.button }}>04:34 PM</span>
//         </div>
//         <div className="text-sm">
//           <span className="font-medium">Close</span>
//           <span className="ml-2" style={{ color: colors.button }}>04:34 PM</span>
//         </div>
//       </div>
      
//       <button
//         className="w-full py-2 px-4 rounded-md font-medium text-sm"
//         style={{
//           backgroundColor: colors.button,
//           color: colors.buttonText
//         }}
//       >
//         Place Bet
//       </button>
//     </div>
//   );
// };

// export default MarketCardLayout1;


import React from 'react';
import ViewAdIcon from 'assets/images/svg/ViewAd.svg';

interface MarketCardLayout1Props {
  colors: {
    background: string;
    text: string;
    button: string;
    buttonText: string;
    status: string;
    border: string;
  };
}

const MarketCardLayout1: React.FC<MarketCardLayout1Props> = ({ colors }) => {
  return (
    <div
      className="rounded-2xl border shadow-md"
      style={{
        backgroundColor: colors.background,
        borderColor: colors.border,
        boxShadow: `0 2px 8px rgba(59,130,246,0.12), inset 0 0 0 1px ${colors.border}`,
      }}
    >
      <div className="p-3">
        {/* Header: Title left, Result number right */}
        <div className="flex items-start justify-between">
          <h3 className="font-semibold text-sm" style={{ color: colors.text }}>MAHADEVI</h3>
          <div className="flex items-center gap-3">
            <div className="font-semibold text-sm" style={{ color: colors.button }}>399-1</div>
            <button
              type="button"
              className="text-xs font-medium inline-flex bg-orange-100 rounded-md px-1 py-1 items-center gap-1"
              style={{ color: colors.button }}
            >
              <img src={ViewAdIcon} alt="View" className="w-3 h-3" />
              View
            </button>
          </div>
        </div>

        {/* Status line */}
        <div className="mt-1 text-[10px]" style={{ color: colors.status }}>
          Betting is running for close
        </div>

        {/* Times pill + Action button */}
        <div className="mt-2 flex items-center gap-1">
          <div className="flex-1 min-w-0">
            <div className="inline-flex items-center gap-2 rounded-md px-1.5 py-1.5 whitespace-nowrap"
                 style={{ backgroundColor: 'rgba(59,130,246,0.08)' }}>
              <span className="text-[9px] font-medium whitespace-nowrap" style={{ color: colors.text }}>Open</span>
              <span className="text-[10px] font-semibold whitespace-nowrap" style={{ color: colors.button }}>04:34 PM</span>
              <span className="text-[9px] font-medium whitespace-nowrap" style={{ color: colors.text }}>Close</span>
              <span className="text-[10px] font-semibold whitespace-nowrap" style={{ color: colors.button }}>04:34 PM</span>
            </div>
          </div>
          <button
            className="shrink-0 rounded-md px-2 py-1.5 text-white font-medium text-[10px] whitespace-nowrap"
            style={{ backgroundColor: colors.button, color: colors.buttonText }}
          >
            Place Bet
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarketCardLayout1;